import React, { useMemo } from 'react';
import { RxText } from 'react-icons/rx';
import {
  AiOutlineNumber,
  AiOutlineCalendar,
  AiOutlineUnorderedList,
  AiOutlineMail,
  AiTwotonePhone,
  AiOutlineGlobal,
  AiOutlineUser,
  AiFillBook,
  AiOutlineCheck,
  AiOutlineBars,
} from 'react-icons/ai';
import ClearbitIcon from 'shared/assets/images/clearbit-icon.svg';
import SixsenseIcon from 'shared/assets/images/sixsense-icon.svg';
import './style.less';
import { OrgIntegrationService } from 'sb-lib/types';

interface Props {
  // includes all possible types (string is the default)
  type:
    | 'string'
    | 'number'
    | 'integer'
    | 'float'
    | 'numeric'
    | 'bool'
    | 'boolean'
    | 'enumeration'
    | 'date'
    | 'datetime'
    | 'email'
    | 'phone'
    | 'url'
    | 'selectMultiple'
    | 'contact'
    | 'company'
    | string;
  // optional label to display otherwise interferes from the type
  label?: string;
}

export const TypeIndicator: React.FC<Props> = ({ type, label }) => {
  const integrationType = useMemo(() => {
    if (label?.toLowerCase()?.includes('clearbit')) {
      return OrgIntegrationService.clearbit;
    }

    if (label?.toLowerCase()?.includes('6sense')) {
      return OrgIntegrationService.sixsense;
    }

    return null;
  }, [label]);

  const [Ticon, formattedLabel] = useMemo(() => {
    switch (integrationType) {
      case OrgIntegrationService.clearbit:
        return [ClearbitIcon, label?.replace('Clearbit', '')];
      case OrgIntegrationService.sixsense:
        return [SixsenseIcon, label?.replace('6sense', '')];
      default:
        return [TypeIcon, label ? label : getTypeLabel(type)];
    }
  }, [integrationType, label, type]);
  return (
    <div className="TypeIndicator">
      <Ticon className="integration-svg" type={type} />
      <span>{formattedLabel}</span>
    </div>
  );
};

export const TypeIcon = ({ type }: { type: string }) => {
  switch (type) {
    case 'string':
      return <RxText className="type-svg" />;
    case 'number':
    case 'integer':
    case 'float':
    case 'numeric':
    case 'numericGteOnly':
      return <AiOutlineNumber className="type-svg" />;
    case 'bool':
    case 'boolean':
      return <AiOutlineCheck className="type-svg" />;
    case 'enumeration':
      return <AiOutlineUnorderedList className="type-svg" />;
    case 'date':
    case 'datetime':
      return <AiOutlineCalendar className="type-svg" />;
    case 'email':
      return <AiOutlineMail className="type-svg" />;
    case 'phone':
      return <AiTwotonePhone className="type-svg" />;
    case 'url':
      return <AiOutlineGlobal className="type-svg" />;
    case 'user':
    case 'contact':
      return <AiOutlineUser className="type-svg" />;
    case 'company':
      return <AiFillBook className="type-svg" />;
    case 'selectMultiple':
      return <AiOutlineBars className="type-svg" />;
    default:
      return null;
  }
};

export const getTypeLabel = (type: string) => {
  switch (type) {
    case 'string':
      return 'Text';
    case 'number':
    case 'integer':
    case 'float':
    case 'numeric':
    case 'numericGteOnly':
      return 'Number';
    case 'bool':
      return 'Boolean';
    case 'enumeration':
      return 'Enumeration';
    case 'date':
    case 'datetime':
      return 'Date';
    case 'email':
      return 'Email';
    case 'phone':
      return 'Phone';
    case 'url':
      return 'URL';
    case 'user':
    case 'contact':
      return 'Contact';
    case 'company':
      return 'Company';
    default:
      return null;
  }
};
